import electoralDistrictImageBefore from "@/assets/images/electoral-bg-before.png"; // Adjust the path as necessary
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { MapPinned } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

interface ElectoralDistrictCardProps {
  id: number;
  title: string;
  className?: string; // Optional className prop for additional styling
}
const ElectoralDistrictCard = ({
  id,
  title,
  className = "", // Default to an empty string if no className is provided
}: ElectoralDistrictCardProps) => {
  return (
    <div
      className={cn(
        "shadow-1 border rounded-md max-w-[25rem] py-5 px-4 w-full relative overflow-hidden group hover:bg-primary-700 transition-all duration-400",
        className
      )}
    >
      <div className="w-[14.5rem] -z-0 h-56 absolute right-[-15.176px] -top-2 transition-all duration-500 ease-in-out group-hover:w-80 group-hover:h-80 group-hover:right-[-20.863px] group-hover:-top-14 group-hover:rotate-[-15.602deg]">
        <Image
          src={electoralDistrictImageBefore}
          alt="before"
          width={300}
          height={300}
          className="object-contain h-full w-full"
        />
      </div>

      <h4 className="uppercase font-semibold text-xl text-primary-700 text-center line-clamp-2  group-hover:text-white transition-colors duration-300">
        {title}
      </h4>
      <div className="p-4 rounded-full bg-primary-700 text-white mx-auto w-fit mt-3 mb-7 group-hover:bg-white group-hover:text-primary-700 transition-colors duration-300">
        <MapPinned />
      </div>
      <div className="flex justify-around relative z-10 gap-2">
        <Link href={`/fraction/${id}`}>
          <Button className="rounded-full bg-primary-700 md:px-6 font-normal group-hover:bg-white group-hover:text-primary-700 transition-colors duration-300 cursor-pointer">
            Anggota Dapil
          </Button>
        </Link>
        <Link href={`/aspiration?dapil=${id}`}>
          <Button className="rounded-full bg-primary-700 md:px-6 font-normal group-hover:bg-white group-hover:text-primary-700 transition-colors duration-300 cursor-pointer">
            Usulan Dapil
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ElectoralDistrictCard;
